// extracted by mini-css-extract-plugin
module.exports = {"modalBackdrop":"Sort_modalBackdrop__aKc9U","modal":"Sort_modal__3r0h9","subtitle":"Sort_subtitle__MZtQO","loadingRoot":"Sort_loadingRoot__fhOjp"};